import { Injectable, inject, DOCUMENT } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  WEB_VIEW_BACKGROUND_PLUGIN_NAME,
  WebViewBackground,
} from './capacitor-plugins';
import { Pwa } from './pwa.service';

/** Matches `#rrggbb` and `#rrggbbaa`, the only forms the native side accepts. */
const HEX_COLOR_REGEX = /^#[0-9a-f]{6}([0-9a-f]{2})?$/i;

@Injectable({
  providedIn: 'root',
})
export class WebViewBackgroundService {
  private document = inject(DOCUMENT);
  private pwa = inject(Pwa);

  /**
   * Makes the native web view background match the page's current background.
   */
  async syncToTheme(): Promise<void> {
    if (
      !this.pwa.isNative() ||
      this.pwa.getPlatform() !== 'ios' ||
      !Capacitor.isPluginAvailable(WEB_VIEW_BACKGROUND_PLUGIN_NAME)
    ) {
      return;
    }

    // `defaultView` is null under server-side rendering, where the computed
    // style is unavailable, so this resolves to undefined instead of throwing.
    const color = this.document.defaultView
      ?.getComputedStyle(this.document.documentElement)
      .getPropertyValue('--color-bg-mid')
      .trim();

    if (color === undefined || !HEX_COLOR_REGEX.test(color)) {
      return;
    }

    await WebViewBackground.setBackgroundColor({ color });
  }
}
